import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-settings",
  "use": "icon-settings-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol viewBox=\"0 0 14 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-settings\">\r\n  <path d=\"M2.42857 11.1429V7.14286M2.42857 4.85714V0.857143M7 11.1429V6M7 3.71429V0.857143M11.5714 11.1429V8.28571M11.5714 6V0.857143M0.714287 7.14286H4.14286M5.28572 3.71429H8.71429M9.85714 8.28571H13.2857\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol